import { trialAccessPreflightRequest } from "../../services/requests/trialAccess";
import { $snack } from "../../services/snack";
const {
  trialAccessErrorMessage,
  updateTrialAccess,
} = require("../../utils/trialAccess");

const trialModuleAccess = ({ next, to, store }) => {
  const module = to.meta.trialModule;
  if (!module) return Promise.resolve();
  const currentAccess = store.getters.getUser?.trial_access;
  if (currentAccess && !currentAccess.enforced) {
    return Promise.resolve();
  }

  return trialAccessPreflightRequest({ module, capability: "edit" })
    .then((response) => {
      updateTrialAccess(store, response.data.data);
    })
    .catch((error) => {
      updateTrialAccess(store, error?.response?.data?.data);
      $snack.error(trialAccessErrorMessage(error));
      next({ name: "dashboard" });
      return Promise.reject(error);
    });
};

export default trialModuleAccess;
